export default __webpack_public_path__ + "static/media/parking-map.551dc73e.jpeg";